import React, { Component } from 'react';
import Logo from '../Components/Logo.js';
import CreateRoom from './CreateRoom.js';
import './Entry.css';

export default class extends Component {
  render() {
    return (
      <div className="room-entry">
        <header>
          <Logo type="white" />
        </header>

        <div className="room-entry-content">
          <div className="hero">
            <div className="hero-text">
              <h1>Estimate with your team, right now.</h1>
              <p>No setup required, just create a room and get going.</p>
            </div>

            <CreateRoom />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Entry/Entry.js